<template>
  <span v-html="rawHtml"></span>
</template>

<script>
export default {
  name: "TextoResaltado",
  props: {
    text: {
      type: String,
      default: ""
    },
    query: {
      type: String,
      default: ""
    }
  },
  computed: {
    rawHtml() {
      var regEx = new RegExp(this.query, "ig");
      return this.text.replace(
        regEx,
        "<span class='resaltar'>" + this.query + "</span>"
      );
    }
  }
};
</script>
